import type { AIMessage } from "@tellescope/ai-agent";

// Single source of truth for root conversation types
// Used for filtering in conversation list queries
export const ROOT_CONVERSATION_TYPES = ["analytics-chat"] as const;
export type RootConversationType = (typeof ROOT_CONVERSATION_TYPES)[number];

export type VisualizationType = "single-stat" | "pie-chart" | "bar-chart" | "time-series" | "table";

export interface InferredVisualization {
  type: VisualizationType;
  dataKey?: string;
  labelKey?: string;
  timestampKey?: string;
  valueKeys?: string[];
}

export interface VisualizationResult {
  inference: InferredVisualization;
  data: Array<Record<string, unknown>>;
}

export interface AIChatMessageWithVisualization extends AIMessage {
  id: string;
  visualization?: VisualizationResult;
}

export interface AskAIState {
  messages: AIChatMessageWithVisualization[];
  isLoading: boolean;
  error: string | null;
  orchestrationId: string | null;
  conversationId: string | null;
}

// Message payload variants stored as JSON in text field
export type ChatMessagePayload =
  | { type: "text"; content: string }
  | {
      type: "analytics-result";
      visualizationType: VisualizationType;
      data: unknown[];
      inference: InferredVisualization;
    }
  | { type: "error"; content: string };

// Parsed message for UI rendering
export interface ParsedChatMessage {
  role: "user" | "assistant";
  timestamp?: Date;
  payload: ChatMessagePayload;
}

// Conversation preview for list view
export interface ConversationPreview {
  id: string;
  preview: string;
  updatedAt: Date;
}
